var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import useRenderingPipeline from './core/hooks/useRenderingPipeline';
//import { SourcePlayback } from './core/helpers/sourceHelper'
//import * as tfBodyPix from '@tensorflow-models/body-pix'
import * as tf from '@tensorflow/tfjs';
import { Md5 } from 'ts-md5/dist/md5';
var PicupVideoCutout = /** @class */ (function () {
    function PicupVideoCutout(token, background, backend, pipeline) {
        this.background = '';
        this.backend = 'wasmSimd';
        this.pipeline = 'webgl2';
        this.bgEnable = true;
        this.rate = 30;
        this.token = token;
        if (background) {
            this.background = background;
        }
        if (backend) {
            this.backend = backend;
        }
        if (pipeline) {
            this.pipeline = pipeline;
        }
        this.cameraInput = document.createElement('video');
        this.canvasTf = document.createElement('canvas');
        //this.canvasTf.id = 'mask_div1';
        this.aVideo = document.createElement('video');
    }
    PicupVideoCutout.prototype.getOutputStream = function () {
        return __awaiter(this, void 0, void 0, function () {
            var timestamp, authData, result, _a, _this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.token) {
                            console.log('token不能为空');
                            throw new Error("token不能为空");
                        }
                        timestamp = Math.floor(new Date().getTime() / 1000);
                        return [4 /*yield*/, fetch('https://picupapi.tukeli.net/api/v1/videoSdk/authorization?timestamp=' + timestamp + '&token=' + this.token)];
                    case 1:
                        authData = _b.sent();
                        if (!authData) {
                            console.log('token验证失败1');
                            throw new Error("token验证失败1");
                        }
                        return [4 /*yield*/, authData.json()];
                    case 2:
                        result = _b.sent();
                        if (!result || !result.data) {
                            console.log('token验证失败2');
                            throw new Error("token验证失败2");
                        }
                        if (result.data != Md5.hashStr(this.token + "randomkey" + timestamp)) {
                            console.log('token验证失败3');
                            throw new Error("token验证失败3");
                        }
                        //console.log('authData-1', authData, result, result.data)
                        //await this.asyncLoadJs('http://127.0.0.1:8080/tflite/tflite.js')
                        return [4 /*yield*/, this.asyncLoadJs('https://deeplor.oss-cn-hangzhou.aliyuncs.com/videosdk/tflite-simd.js')
                            //await this.asyncLoadJs('http://127.0.0.1:3000/virtual-background/tflite/tflite-simd.js')
                        ];
                    case 3:
                        //console.log('authData-1', authData, result, result.data)
                        //await this.asyncLoadJs('http://127.0.0.1:8080/tflite/tflite.js')
                        _b.sent();
                        //await this.asyncLoadJs('http://127.0.0.1:3000/virtual-background/tflite/tflite-simd.js')
                        console.log('Loading TensorFlow.js and BodyPix segmentation model');
                        return [4 /*yield*/, tf.ready()
                            //this.bodyPix = await tfBodyPix.load()
                        ];
                    case 4:
                        _b.sent();
                        //this.bodyPix = await tfBodyPix.load()
                        console.log('TensorFlow.js and BodyPix loaded');
                        //this.tflite = await createTFLiteModule()
                        _a = this;
                        return [4 /*yield*/, createTFLiteSIMDModule()];
                    case 5:
                        //this.tflite = await createTFLiteModule()
                        _a.tfliteSIMD = _b.sent();
                        console.log('getOutputStream-1', this.tfliteSIMD);
                        return [4 /*yield*/, this.loadTFLiteModel()];
                    case 6:
                        _b.sent();
                        _this = this;
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                navigator.mediaDevices.getUserMedia({ video: true, audio: false })
                                    .then(function (stream) {
                                    _this.mediaStream = stream;
                                    console.log('mediaStream-1', _this.mediaStream);
                                    _this.aVideo.srcObject = stream;
                                    _this.aVideo.onloadedmetadata = function () {
                                        console.log('aVideo', _this.aVideo.videoWidth, _this.aVideo.videoHeight);
                                        _this.aVideo.width = _this.aVideo.videoWidth;
                                        _this.aVideo.height = _this.aVideo.videoHeight;
                                        console.log('aVideo-2', _this.aVideo.width, _this.aVideo.height);
                                        _this.aVideo.play();
                                        _this.sourcePlayback = {
                                            htmlElement: _this.aVideo,
                                            width: _this.aVideo.videoWidth,
                                            height: _this.aVideo.videoHeight,
                                        };
                                        _this.canvasTf.width = _this.sourcePlayback.width;
                                        _this.canvasTf.height = _this.sourcePlayback.height;
                                        _this.loadAndPredict();
                                        resolve(_this.canvasTf.captureStream());
                                        //resolve(_this.canvasTf);
                                    };
                                    //resolve(stream);
                                    //resolve(_this.canvasTf.captureStream());
                                    //resolve(_this.canvasTf);
                                })
                                    .catch(function (err) {
                                    console.log('Camera Error: ' + err.name + ' ' + err.message);
                                    reject(err);
                                });
                            })];
                }
            });
        });
    };
    PicupVideoCutout.prototype.asyncLoadJs = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var script = document.createElement('script');
                        script.type = 'text/javascript';
                        script.src = url;
                        document.body.appendChild(script);
                        script.onload = function () {
                            resolve('success');
                        };
                        script.onerror = function () {
                            reject('error');
                        };
                    })];
            });
        });
    };
    PicupVideoCutout.prototype.loadTFLiteModel = function () {
        return __awaiter(this, void 0, void 0, function () {
            var newSelectedTFLite, modelResponse, model, modelUnit8ArrayStep0, modelUnit8Array, modelBufferOffset;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newSelectedTFLite = this.backend === 'wasmSimd' ? this.tfliteSIMD : this.tflite;
                        if (!newSelectedTFLite) {
                            throw new Error("TFLite backend unavailable: ".concat(this.backend));
                        }
                        return [4 /*yield*/, fetch('https://deeplor.oss-cn-hangzhou.aliyuncs.com/videosdk/modelv2.data')
                            //const modelResponse = await fetch('http://127.0.0.1:3000/virtual-background/models/segm_full_v679.tflite')
                        ];
                    case 1:
                        modelResponse = _a.sent();
                        return [4 /*yield*/, modelResponse.arrayBuffer()];
                    case 2:
                        model = _a.sent();
                        modelUnit8ArrayStep0 = new Uint8Array(model, 40);
                        modelUnit8Array = modelUnit8ArrayStep0.reverse();
                        console.log('Model buffer size:', model.byteLength);
                        modelBufferOffset = newSelectedTFLite._getModelBufferMemoryOffset();
                        console.log('Model buffer memory offset:', modelBufferOffset);
                        console.log('Loading model buffer...');
                        newSelectedTFLite.HEAPU8.set(modelUnit8Array, modelBufferOffset);
                        console.log('_loadModel result:', newSelectedTFLite._loadModel(model.byteLength));
                        console.log('Input memory offset:', newSelectedTFLite._getInputMemoryOffset());
                        console.log('Input height:', newSelectedTFLite._getInputHeight());
                        console.log('Input width:', newSelectedTFLite._getInputWidth());
                        console.log('Input channels:', newSelectedTFLite._getInputChannelCount());
                        console.log('Output memory offset:', newSelectedTFLite._getOutputMemoryOffset());
                        console.log('Output height:', newSelectedTFLite._getOutputHeight());
                        console.log('Output width:', newSelectedTFLite._getOutputWidth());
                        console.log('Output channels:', newSelectedTFLite._getOutputChannelCount());
                        this.selectedTFLite = newSelectedTFLite;
                        return [2 /*return*/];
                }
            });
        });
    };
    PicupVideoCutout.prototype.loadAndPredict = function () {
        return __awaiter(this, void 0, void 0, function () {
            var backgroundConfig, segmentationConfig, backgroundImage;
            var _this_1 = this;
            return __generator(this, function (_a) {
                //let newPipeline = new useRenderingPipeline(this.selectedTFLite, this.pipeline, this.sourcePlayback, this.backend)
                //newPipeline.render()
                if (this.background == 'blur') {
                    this.blur();
                    return [2 /*return*/];
                }
                if (!this.background) {
                    this.disable();
                    return [2 /*return*/];
                }
                backgroundConfig = {
                    type: "image",
                    url: this.background
                };
                segmentationConfig = {
                    model: 'meet',
                    backend: this.backend,
                    inputResolution: '256x144',
                    pipeline: this.pipeline
                };
                backgroundImage = new Image();
                backgroundImage.crossOrigin = '';
                backgroundImage.src = this.background;
                backgroundImage.onload = function () {
                    console.log('loadAndPredict-1', _this_1.rate);
                    var _a = useRenderingPipeline(_this_1.sourcePlayback, backgroundConfig, segmentationConfig, _this_1.selectedTFLite, _this_1.canvasTf, backgroundImage, Math.ceil(1000 / _this_1.rate)), pipeline = _a.pipeline, backgroundImageRef = _a.backgroundImageRef, canvasRef = _a.canvasRef, fps = _a.fps, durations = _a.durations, stop = _a.stop, changeFrameRate = _a.changeFrameRate;
                    _this_1.stopRender = stop;
                    _this_1.changeFrameRate = changeFrameRate;
                    console.log('loadAndPredict-2', typeof _this_1.stopRender, _this_1.stopRender);
                };
                return [2 /*return*/];
            });
        });
    };
    PicupVideoCutout.prototype.changeBackground = function (background) {
        console.log('changeBackground-1', background);
        if (background == 'blur') {
            this.blur();
            return;
        }
        if (this.stopRender) {
            this.stopRender();
        }
        this.background = background;
        this.loadAndPredict();
        this.bgEnable = true;
    };
    PicupVideoCutout.prototype.disable = function () {
        if (!this.bgEnable) {
            return;
        }
        if (this.stopRender) {
            this.stopRender();
        }
        console.log('disable-1');
        var backgroundConfig = {
            type: "none"
        };
        var segmentationConfig = {
            model: 'meet',
            backend: this.backend,
            inputResolution: '256x144',
            pipeline: this.pipeline
        };
        console.log('disable-2', this.rate);
        var _a = useRenderingPipeline(this.sourcePlayback, backgroundConfig, segmentationConfig, this.selectedTFLite, this.canvasTf, null, Math.ceil(1000 / this.rate)), pipeline = _a.pipeline, backgroundImageRef = _a.backgroundImageRef, canvasRef = _a.canvasRef, fps = _a.fps, durations = _a.durations, stop = _a.stop, changeFrameRate = _a.changeFrameRate;
        this.stopRender = stop;
        this.changeFrameRate = changeFrameRate;
        this.bgEnable = false;
    };
    PicupVideoCutout.prototype.enable = function () {
        if (this.bgEnable) {
            return;
        }
        if (this.stopRender) {
            this.stopRender();
        }
        console.log('enable-1');
        this.loadAndPredict();
        this.bgEnable = true;
    };
    PicupVideoCutout.prototype.stop = function () {
        if (this.stopRender) {
            this.stopRender();
        }
        if (this.mediaStream) {
            var tracks = this.mediaStream.getTracks();
            tracks.forEach(function (track) { return track.stop(); });
            this.mediaStream = null;
        }
    };
    PicupVideoCutout.prototype.requestFrameRate = function (rate) {
        if (this.changeFrameRate) {
            if (rate > 30) {
                rate = 30;
            }
            this.rate = rate;
            this.changeFrameRate(rate);
        }
    };
    PicupVideoCutout.prototype.blur = function () {
        if (this.stopRender) {
            this.stopRender();
        }
        console.log('blur-1');
        var backgroundConfig = {
            type: "blur"
        };
        var segmentationConfig = {
            model: 'meet',
            backend: this.backend,
            inputResolution: '256x144',
            pipeline: this.pipeline
        };
        console.log('blur-2', this.rate);
        var _a = useRenderingPipeline(this.sourcePlayback, backgroundConfig, segmentationConfig, this.selectedTFLite, this.canvasTf, null, Math.ceil(1000 / this.rate)), pipeline = _a.pipeline, backgroundImageRef = _a.backgroundImageRef, canvasRef = _a.canvasRef, fps = _a.fps, durations = _a.durations, stop = _a.stop, changeFrameRate = _a.changeFrameRate;
        this.stopRender = stop;
        this.changeFrameRate = changeFrameRate;
        this.bgEnable = true;
    };
    return PicupVideoCutout;
}());
export default PicupVideoCutout;
